// extracted by mini-css-extract-plugin
export default {"oosNotify":"r6-z","count":"s6-z","otherColors":"t6-z","modalContent":"u6-z","body":"v6-z"};